// components/Schedule.jsx
import React, { useEffect, useMemo, useState } from 'react';
import { addDays, parse, format } from 'date-fns';
import css from './Schedule.module.css';
import * as courseServices from '../../../../services/courseServices.js';

import ZoomControls from './ZoomControls';
import DateRangePicker from './DateRangePicker';
import CalendarTable from './CalendarTable';
import Tooltip from './Tooltip';

const ZOOM_LEVELS = { day: 100, week: 50, month: 20 };
const CATEGORY_WIDTH = 200;

function Schedule() {
    const [courses, setCourses] = useState([]);
    const [displayPeriod, setDisplayPeriod] = useState({
        startDate: new Date('2026-01-01'),
        endDate: new Date('2026-12-31'),
        dates: [new Date('1900-01-01')],
        totalDays: 0,
    });
    const [zoom, setZoom] = useState('month');
    const [tooltip, setTooltip] = useState({ visible: false, content: '', x: 0, y: 0 });
    const cellWidth = ZOOM_LEVELS[zoom];

    const localDateParser = (courseDate) => {
        const parsed = parse(courseDate, 'dd-MMM-yyyy', new Date());
        return format(parsed, 'yyyy-MM-dd');
    };

    const colors = useMemo(
        () => ({
            Planned: '#f87171',
            'In progress': '#fbbf24',
            Closed: '#9ca3af',
            Acquisition: '#34d399',
            // 'Planned': '#60a5fa',
            // 'In Progress': '#f87171',
            // 'Closed': '#f472b6',
        }),
        []
    );
    useEffect(() => {
        courseServices
            .getAll(1)
            .then((result) => {
                const items = result.data
                    .map((x) => ({
                        id: x.ID,
                        title: x.Title,
                        category: x.Status,
                        start: localDateParser(x.Start),
                        end: localDateParser(x.End),
                        color: colors[x.Status] || '#9ca3af',
                        courseNo: x.No,
                    }))
                    .filter((x) => new Date(x.end) >= new Date(displayPeriod.startDate));
                setCourses(items);
            })
            .catch(console.log);
    }, [colors, displayPeriod.startDate]);

    useEffect(() => {
        let current = new Date(displayPeriod.startDate);
        const dates = [];
        while (current <= new Date(displayPeriod.endDate)) {
            dates.push(new Date(current));
            current = addDays(current, 1);
        }
        setDisplayPeriod((prev) => ({ ...prev, dates, totalDays: dates.length }));
    }, [displayPeriod.startDate, displayPeriod.endDate]);

    return (
        <div className={css.container}>
            <ZoomControls zoom={zoom} setZoom={setZoom} ZOOM_LEVELS={ZOOM_LEVELS} />
            <DateRangePicker displayPeriod={displayPeriod} setDisplayPeriod={setDisplayPeriod} />

            <div className={css.scrollContainer}>
                <CalendarTable
                    courses={courses}
                    displayPeriod={displayPeriod}
                    cellWidth={cellWidth}
                    CATEGORY_WIDTH={CATEGORY_WIDTH}
                    tooltip={tooltip}
                    setTooltip={setTooltip}
                />
            </div>
            {tooltip.visible && <Tooltip tooltip={tooltip} />}
        </div>
    );
}

export default Schedule;
